import { WorkOrderPoPagination } from "api/models/response/pagination";
import { formatNumber } from "commons/ultilities";
import { flow, types } from "mobx-state-tree";
import { withRootStore } from "mobx-stores/_extension/with-root-store";

import { workOrderPoBusiness } from "api/bussiness/work-order-po/work-order-po-bussiness";
import { GetWorkOrdersPo } from "api/models/request/work-order-po/work-order-po";
import { withReset } from "mobx-stores/_extension/with-reset";
import {
  IWorkOrderPoProperties,
  WorkOrderPo,
} from "mobx-stores/_models/work-order-po/work-order-po";
import { withSetPropAction } from "../_extension/with-set-props";
import { DateRangeFilterStore } from "./common/date-range-filter-store";
import { PaginationStore } from "./common/pagination-store";

export const WorkOrderPoPrintingManagement = types
  .model({
    openPrintOnFrontPreview: false,
    openPrintOnBackPreview: false,
  })
  .actions(withSetPropAction)
  .actions(withReset);

export const WoPoUpdateDepartmentProcess = types
  .model({
    open: false,
    woItemId: types.maybeNull(types.string),
    type: types.maybeNull(types.number),
    amount: types.maybeNull(types.number),
    date: types.maybeNull(types.string),
  })
  .actions(withSetPropAction)
  .actions(withReset);

export const WorkOrderPoQueryParams = types
  .model({
    name: "",
    dealingName: "",
    code: "",
    barcode: "",
    wONumber: "",
    dateRangeFilter: types.optional(DateRangeFilterStore, {}),
    poDateRangeFilter: types.optional(DateRangeFilterStore, {}),
    purchaseOrderId: "",
    statusId: "",
    customerId: "",
    wOBatchNumber: "",
    includeHiddenOrder: false,
    isCompensating: false,
    isExactMatch: true
  })
  .actions(withSetPropAction)
  .actions(withReset);
export const WorkOrderPoManagement = types
  .model({
    workOrdersPo: types.optional(types.array(WorkOrderPo), []),
    pagination: types.optional(PaginationStore, {}),
    workOrderPoDetail: types.maybeNull(WorkOrderPo),
    openNew: false,
    openEdit: false,
    openUpdateStatus: false,
    openDelete: false,
    openPackagePrint: false,
    updateDepartmentProcess: types.optional(WoPoUpdateDepartmentProcess, {}),
    queryParams: types.optional(WorkOrderPoQueryParams, {}),
    totalAmount: types.maybeNull(types.number),
    totalWeight: types.maybeNull(types.number),
    searchConditionAsNaturalLanguage: "",
    workOrderPoPrintingManagement: types.optional(
      WorkOrderPoPrintingManagement,
      {},
    ),
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .actions((self) => ({
    createSearchConditionAsNaturalLanguage() {
      const totalWorkOrder =
        typeof self.pagination.totalItems === "number"
          ? formatNumber(self.pagination.totalItems)
          : "";
      const totalAmount =
        typeof self.totalAmount === "number"
          ? formatNumber(self.totalAmount)
          : "";
      const totalWeight =
        typeof self.totalWeight === "number"
          ? formatNumber(self.totalWeight)
          : "";

      return `Tổng Số Lệnh: ${totalWorkOrder} - Số Lượng Sản Xuất: ${totalAmount} pcs - Trọng Lượng Sản Xuất: ${totalWeight} kg`;
    },
  }))
  .actions((self) => ({
    getWorkOrdersPo: flow(function* getWorkOrdersPo(request?: GetWorkOrdersPo) {
      try {
        self._rootStore.setProp("inProgress", true);
        const requestModel = request ?? {
          filter: self.pagination.filter,
          maxResultCount: self.pagination.itemsPerPage,
          skipCount: self.pagination.skipCount,
          sorting: "",
          fromDate:
            self.queryParams.dateRangeFilter.fromAsDayJs?.isValid() &&
            self.queryParams.dateRangeFilter.from
              ? self.queryParams.dateRangeFilter.from
              : undefined,
          toDate:
            self.queryParams.dateRangeFilter.toAsDayJs?.isValid() &&
            self.queryParams.dateRangeFilter.to
              ? self.queryParams.dateRangeFilter.to
              : undefined,
          fromPODate:
            self.queryParams.poDateRangeFilter.fromAsDayJs?.isValid() &&
            self.queryParams.poDateRangeFilter.from
              ? self.queryParams.poDateRangeFilter.from
              : undefined,
          toPODate:
            self.queryParams.poDateRangeFilter.toAsDayJs?.isValid() &&
            self.queryParams.poDateRangeFilter.to
              ? self.queryParams.poDateRangeFilter.to
              : undefined,
          dealingName: self.queryParams.dealingName,
          name: self.queryParams.name,
          code: self.queryParams.code,
          barcode: self.queryParams.barcode,
          wONumber: self.queryParams.wONumber,
          customerId: self.queryParams.customerId,
          purchaseOrderId: self.queryParams.purchaseOrderId,
          statusId: self.queryParams.statusId,
          wOBatchNumber: self.queryParams.wOBatchNumber,
          includeHiddenOrder: self.queryParams.includeHiddenOrder,
          isCompensating: self.queryParams.isCompensating,
          isExactMatch: self.queryParams.isExactMatch
        };
        const res = (yield workOrderPoBusiness.getLists(
          requestModel,
        )) as WorkOrderPoPagination<IWorkOrderPoProperties>;
        self.setProp("workOrdersPo", res.items ?? []);
        self.setProp("totalAmount", res.totalProductionAmount ?? null);
        self.setProp("totalWeight", res.totalWeight ?? null);
        self.pagination.setProp("totalItems", res.totalCount);
        self.setProp(
          "searchConditionAsNaturalLanguage",
          self.createSearchConditionAsNaturalLanguage(),
        );
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
    getWorkOrderPoDetail: flow(function* getWorkOrderPoDetail(id: string) {
      try {
        self._rootStore.setProp("inProgress", true);
        const res = (yield workOrderPoBusiness.getById(
          id,
        )) as IWorkOrderPoProperties;
        self.setProp("workOrderPoDetail", res);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
  }));
